module.exports = __webpack_public_path__ + "static/media/infoJumbo1.670f0211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/davi/images/infoJumbo1.jpg
// module id = 510
// module chunks = 0